import * as React from 'react';
import { fetchData } from '../utils'
import { Helmet } from "react-helmet";
import * as AuthStore from "../store/Auth";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { ApplicationState } from '../store';
import { Upload, message, Row, Col } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import * as moment from 'moment';
const { Dragger } = Upload;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class UploadData extends React.PureComponent<AuthProps>
{

    fileControlClicked()
    {
        var ecl = document.getElementById("txSel");
        if (ecl)
            ecl.click();
    }
    public state =
    {
        loading: false,
    }

    async componentDidMount()
    {  
        
    }

    startUpload()
    {
        this.setState({ hideUpload: true });
    }

    public render()
    {
        const { appUser } = this.props;
        if (!appUser.isAuthenticated || appUser.role === "2")
        {
            return <Redirect to="/welcome" />;
        }

        const props =
        {
            name: 'file',
            multiple: true,
            accept: '.zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed',
            action: '/api/Site/uploadNmrs',
            onChange(info: { file: { name?: any; status?: any; }; fileList: any; })
            {
                const { status } = info.file;

                console.log(info);

                if (status !== 'uploading')
                {
                    console.log(info.file, info.fileList);
                }
                if (status === 'done')
                {
                    message.success(`${info.file.name} file uploaded successfully.`);
                }
                else if (status === 'error')
                {
                    message.error(`${info.file.name} file upload failed.`);
                }
            }
        };

        return (
            <React.Fragment>
                <div style={{ marginLeft: 'auto', marginRight: 'auto', backgroundColor: '#fff', paddingBottom: '40px' }}>
                    <Helmet>
                        <title>CDR - Upload Files</title>
                    </Helmet>
                    <Row style={{ paddingTop: '20px', marginBottom: '20px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Upload Data</h4>
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: '20px', marginBottom: '20px' }}>
                        <Col xs={24} sm={3} md={3} lg={3} xl={3}></Col>
                        <Col className="mUpload" xs={24} sm={12} md={18} lg={18} xl={18} style={{ textAlign: 'center'}}>
                            <Dragger {...props}>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Click or drag data file (s) to this area to upload</p>
                            </Dragger>
                        </Col>
                        <Col xs={24} sm={3} md={3} lg={3} xl={3}></Col>
                    </Row>
                </div>               
              
            </React.Fragment>
        );
    }
};

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(UploadData as any);
